/**
 * Who may approve a change order (ISS-514).
 *
 * Nick's rulings: (2026-10-03) there is no two-person rule for change orders; a
 * project manager may approve their own, and the self-approval is recorded
 * (`selfApproved: true`, plus `createdBy` and `approvedBy`). (2026-10-04, after
 * measuring that only a Manager has ever approved one) ALL change order approval,
 * own or someone else's, is restricted to those project managers. "Project
 * manager" means an OfficeHub role of Owner, Admin or Manager; Projects (P10)
 * module access is enforced separately by the callable's `withModuleAccess("P10")`.
 *
 * This is the ONE copy of the rule. The server (functions/src/projects) is the
 * authority and reads the role from the caller's users doc; the client uses the
 * same function only to decide which menu item to show.
 */

/** Roles allowed to approve a change order, their own or anyone's. */
export const CHANGE_ORDER_APPROVER_ROLES: readonly string[] = Object.freeze([
  'Owner',
  'Admin',
  'Manager',
]);

/** True when the approver is the change order's creator. */
export function isChangeOrderSelfApproval(
  createdBy: string | null | undefined,
  approverId: string | null | undefined,
): boolean {
  return typeof approverId === 'string' && approverId.length > 0 && createdBy === approverId;
}

/** True when a user with `role` may approve a change order (own or someone else's). */
export function canApproveChangeOrder(role: unknown): boolean {
  return typeof role === 'string' && CHANGE_ORDER_APPROVER_ROLES.includes(role);
}
